<template>
    <div>
        <template v-if="multiple">
            <a-input v-model="storeNumName" read-only>
                <template slot="addonAfter">
                    <a-button type="link" size="small" icon="search" @click="showChoose()" slot="addonAfter" />
                </template>
            </a-input>
        </template>
        <template v-else>
            <a-input v-model="selectName" placeholder="请选择商户" allowClear read-only>
                <template slot="addonAfter">
                    <a-tooltip title="选择商户">
                        <a-button type="link" size="small" icon="search" @click="showChoose()" />
                    </a-tooltip>
                    <a-tooltip title="清空">
                        <a-button type="link" size="small" icon="delete" @click="clear()" v-if="allowClear" />
                    </a-tooltip>
                </template>
            </a-input>
        </template>
        <a-modal v-model:visible="visible" title="选择商户" width="40%" @ok="confirm()">
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between" :gutter="12">
                        <a-col span="12">
                            <a-input-search v-model="param.keyword" allowClear search @pressEnter="doRefresh"
                                @on-clear="doRefresh" placeholder="关键词查询" @search="doRefresh"
                                enter-button></a-input-search>
                        </a-col>
                        <a-col span="12">
                            <a-row type="flex" align="middle" justify="end" :gutter="3">
                                <a-col span="24">
                                    <choose-organ v-model="param.organId" @change="doRefresh" allowClear></choose-organ>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
            <div>
                <a-table :columns="keys" rowKey="storeId" :pagination="false" :data-source="data.records" size="small"
                    :rowSelection="{ selectedRowKeys: this.ids, type: multiple ? 'checkbox' : 'radio', hideDefaultSelections: !multiple, fixed: true, selections: true, onChange: this.changeData }"
                    :customRow="customRow" :loading="loading">
                </a-table>
            </div>
            <a-row>
                <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                    <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                        @showSizeChange="setLimit" :current="data.current" size="small" simple />
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
/**
 * //单选
 * <choose-store v-model="formData.storeId" :name="formData.storeName" allowClear />
 * //多选
 * <choose-store v-model="formData.scopeList" multiple></choose-store>
 * 
 */
import request from '@/config/request'
import apiUtil from '@/common/apiUtil'
import utils from '@/common/utils'
export default {
    data() {
        return {
            visible: false,
            loading: false,
            data: { records: [] },
            param: {
                page: 1,
                limit: 20,
                keyword: '',
                organId: apiUtil.getDefaultOrganId()
            },
            organList: apiUtil.getOrganList(),
            keys: [
                { title: '商户名称', dataIndex: 'name', align: 'left', tooltip: true, ellipsis: true },
                { title: '地址', dataIndex: 'address', width: 200, ellipsis: true },
                { title: '备注', dataIndex: 'remark', width: 120, ellipsis: true },
                // { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 100 }
            ],
            //已选择的商户(未确认)
            ids: [],
            selectKeys: [],//已选择的商户(已确认)
            selectName: this.name,//已选择的商户名称
        }
    },
    mounted() {
        let defaultIds = [];
        if (this.value) {
            if (typeof this.value === 'string') {
                defaultIds = this.value.split(',').map(Number);
            } else if (Array.isArray(this.value)) {
                defaultIds = [...this.value];
            }
        }
        this.ids = defaultIds;
        this.selectKeys = defaultIds;
    },
    computed: {
        storeNumName() {
            return '已选择' + this.selectKeys.length + "个商户";
        }
    },
    methods: {
        confirm() {
            this.visible = false;
            this.selectKeys = this.ids;
            this.$emit('input', this.ids.join(','));
        },
        clear() {
            this.selectKeys = [];
            this.selectName = '';
            this.$emit('input', '');
        },
        changeData(e, row) {
            if (this.multiple) {
                this.ids = e;
                return;
            }
            if (e.length > 1) {
                utils.warning('只能选择一个商户');
                return;
            }
            this.ids = e;
            this.selectName = row[0]['name'];
        },
        customRow(record, index) {
            return {
                on: {
                    click: () => {
                        //多选
                        if (this.multiple) {
                            if (this.ids.includes(record.storeId)) {
                                this.ids = this.ids.filter(item => item !== record.storeId);
                            } else {
                                this.ids.push(record.storeId);
                            }
                            return;
                        }
                        //单选
                        this.ids = [record.storeId];
                        this.selectName = record.name;
                    }
                }
            };
        },
        showChoose() {
            this.visible = true;
            this.doRefresh();
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        // 获取数据
        getList() {
            this.loading = true;
            request
                .get('/platform/store/list', this.param)
                .then(ret => {
                    // console.log(ret.data)
                    this.data = ret.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    },
    watch: {
        value: {
            handler(val) {
                let defaultIds = [];
                if (val) {
                    //字符串转换数组
                    if (typeof val == 'string') {
                        val.split(',').forEach(item => {
                            defaultIds.push(parseInt(item));
                        });
                    } else {
                        defaultIds = val;
                    }
                }
                this.ids = defaultIds;
                this.selectKeys = defaultIds;
            },
            deep: false,
            immediate: false
        }
    },
    props: {
        value: {
            type: Array | String,
            default: () => {
                return [];
            }
        },
        name: {
            type: String,
            default: ''
        },
        allowClear: {
            type: Boolean,
            default: false
        },
        //是否可多选
        multiple: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
    }
}
</script>

<style></style>